var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-input",style:(_vm.styleParent)},[_c('div',{staticClass:"form"},[_c('i',{staticClass:"fa fa-search"}),_c('input',{style:(_vm.styleInput),attrs:{"type":"search","placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('search-input-updated', $event)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }